import {
  FetchPlugin,
  getAlfMockAdapter,
  MockInterceptFetch,
  MockInterceptRequest,
  RequestPlugin,
} from '@ama-sdk/core';
import {
  Platform,
} from '@angular/cdk/platform';
import {
  EventTrackService,
} from '@o3r/analytics';
import {
  ApiManager,
} from '@o3r/apis-manager';
import {
  LoggerService,
} from '@o3r/logger';
import {
  AnalyticsOfficeIDService,
} from '@refx/analytics-core';
import {
  AppTokenParametersService,
} from '@refx/booking-services';
import {
  AppBootstrapConfig,
  BotProtectionFactory,
  ExtraPluginsByAPI,
} from '@refx/shared-common';
import {
  AppInitializationService,
  createApiManagerFactory,
} from '@refx/shared-services';
import {
  isAlfMockScenario,
  mockAdapter,
} from '../mock/mock-adapter';

/**
 * Factory that creates the API manager configuration for the application
 *
 * @param config
 * @param botProtectionFactory
 * @param eventTrackService
 * @param appInitializationService
 * @param platform
 * @param tokenParametersService
 * @param analyticsOfficeIDService The service to set office id in analytics
 * @param extraPluginsByAPI
 * @param loggerService
 */
export function createApisFactoryBooking(
  config: AppBootstrapConfig,
  botProtectionFactory: BotProtectionFactory,
  eventTrackService: EventTrackService,
  appInitializationService: AppInitializationService,
  platform: Platform,
  tokenParametersService: AppTokenParametersService,
  analyticsOfficeIDService: AnalyticsOfficeIDService,
  extraPluginsByAPI: ExtraPluginsByAPI,
  loggerService?: LoggerService
): ApiManager {
  const fetchPlugins: FetchPlugin[] = [];
  const requestPlugins: RequestPlugin[] = [];
  const useMocks = appInitializationService.shouldUseMocks();
  const searchData = appInitializationService.getSearchDetails();
  const metaSearchData = appInitializationService.getMetaSearchData();
  const portalFacts = appInitializationService.getPortalFacts();
  const factCallback = tokenParametersService.getFactsForTokenCall(searchData, portalFacts, metaSearchData);
  const guestOfficeId = tokenParametersService.getOfficeIdFromStore();
  const officeIdCallback = analyticsOfficeIDService.getOfficeIdCallBack();

  if (useMocks) {
    /** Request interceptor that only kicks in if exists query parameter useMocks */
    const scenario = appInitializationService.getScenario();
    const adapter = isAlfMockScenario(scenario)
      ? getAlfMockAdapter(
        scenario!,
        () => import('@dapi/sdk/spec').then(({OPERATION_ADAPTER}) => OPERATION_ADAPTER)
      ) : mockAdapter;
    requestPlugins.push(new MockInterceptRequest({
      adapter: adapter
    }));
    fetchPlugins.push(new MockInterceptFetch({
      adapter: adapter
    }));
  }

  return createApiManagerFactory(
    config,
    botProtectionFactory,
    eventTrackService,
    appInitializationService,
    platform,
    fetchPlugins,
    requestPlugins,
    [],
    extraPluginsByAPI,
    guestOfficeId,
    officeIdCallback,
    undefined,
    factCallback,
    loggerService
  );
}
